import {Funcao, Grupo} from "./enums";
import {Column, Entity, PrimaryColumn} from "typeorm";

@Entity("taxon")
export class Taxon {
    @PrimaryColumn({name:"docid"})
    id?: string

    guid?: string
    @Column()
    name?: string
    @Column()
    rank?: string
    nameFormatted?: string
    @Column()
    author?: string
    parentGuid?: string
    @Column("simple-array")
    commonNames?: string
    @Column("simple-array")
    status?: any[]
    @Column()
    grupo?: Grupo
    updatedAt?: Date

    get nameFull(): string|undefined {
      let retorno = this.name
      if (this.commonNames) {
        const nomes = JSON.parse(this.commonNames)
        if (nomes.length > 0) {
          retorno += " (" + nomes.join(",") + ")"
        }
      }
      return retorno
    }

    get nomesComuns(): string|undefined {
      return this.commonNames ? JSON.parse(this.commonNames).join(","):""
    }
}
